import { useGetDMaxCommon, type AroundDmaxInfoResponse, type SpecialDmaxInfoResponse } from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { BackBanner, OtherSpecial, SpecialDetail, Travel } from "../common";
import { TopSection } from "../common/components/topSection";

export const Specials = () => {
    const { specialIdx } = useParams<string>();
    const { data: special } = useGetDMaxCommon<SpecialDmaxInfoResponse>({ section: "special" });
    const { data: around } = useGetDMaxCommon<AroundDmaxInfoResponse>({ section: "around" });
    if (!specialIdx) {
        // 404로 요청
        return <div>404로 요청합니다</div>;
    }
    const targetSpecial = special?.specials.find((t) => t.special_idx === specialIdx);
    const sector = {
        main: {
            firstLine: targetSpecial?.special_name.eng || "",
            secondLine: targetSpecial?.special_name.kor || "",
        },
        sub: {
            firstLine: "",
            secondLine: "",
        },
    };

    const otherSpecialList = special?.specials.filter((t) => t.special_idx !== specialIdx);

    return targetSpecial && around && otherSpecialList ? (
        <>
            <TopSection sector={sector} imgList={targetSpecial?.imgList} />
            <SpecialDetail special={targetSpecial} />
            <BackBanner imgUrl={targetSpecial.imgList[0] ? targetSpecial.imgList[0].img_URL : undefined} />
            <OtherSpecial specials={otherSpecialList} />
            {around.isUse && <Travel around={around} />}
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
